module.exports = __webpack_public_path__ + "static/media/chip.35b5a575.svg";